import * as React from "react";

import DatePicker from "react-widgets/DatePicker";

interface GroupExpirationDatePickerProps {
  currentValue?: string
}

export default function GroupExpirationDatePicker(props: GroupExpirationDatePickerProps) {
  const {
    currentValue,
  } = props;

  return (
    <DatePicker
      defaultValue={currentValue ? new Date(currentValue) : undefined}
      valueFormat={{day: "numeric", year: "numeric", month: "numeric"}}
      {...props}
    />
  );
}
